export class InvoiceTypeArgumentModel
{
    public current_date: Date;
    public invoice_type : string;
    public group_id: string;
    public get_item_summaries: boolean;
}
